import styled from 'styled-components';
import { Form } from 'formik';

export default styled(Form)`
  .ant-form-item {
    margin-bottom: 5px;
    .ant-form-item-label {
      padding-bottom: 0;
    }
  }
`;
